import React, { useMemo } from 'react';

import { ACTION_RESPONSE_INTER, DATA_INTER, MODULE_NAME } from './constant';
import { Component } from './component';
import { action } from './action';
import { ACTION_ERROR_INTER } from '../event-list/constant';
import { useQuery } from 'react-query';

export const Container: React.FC<{}> = ({}) => {
  const preFetch = useQuery({
    queryKey: [MODULE_NAME],
    queryFn: () => action(),
    staleTime: Infinity,
  });

  const isLoading = () => {
    if (preFetch.isLoading || preFetch.isFetching) {
      return true;
    }
  };

  const isSuccess = () => {
    if (preFetch.isSuccess && !preFetch.isFetching) {
      return true;
    }
  };

  const isError = () => {
    if (preFetch.isError && !preFetch.isLoading && getErrorMessage()) {
      return true;
    }
  };

  const getErrorMessage = () => {
    const error: ACTION_ERROR_INTER = preFetch.error as ACTION_ERROR_INTER;

    if (error) {
      return error.message;
    }
  };

  const getData = useMemo((): DATA_INTER | undefined => {
    const data = preFetch.data as unknown as ACTION_RESPONSE_INTER;

    if (data) {
      return { list: preFetch.data, isEmpty: data?.list?.length < 1 };
    }
  }, [preFetch?.data]);

  return (
    <Component
      data={getData}
      isLoading={isLoading()}
      isError={isError()}
      isSuccess={isSuccess()}
      errorMessage={getErrorMessage()}
    />
  );
};
